import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({name: 'value'})
export class DisplayValuePipe implements PipeTransform {
   constructor() {

   }

   transform(choice: number, stringIndex: number): string {
      return this.swithContent(this.declareChoiceString(choice),
         stringIndex);
   }

   declareChoiceString(choice: number) {
      let _text = '';
         switch (choice) {
            case 0:
               _text = 'yes/no';
               break;
            case 1:
               _text = 'true/false';
               break;
            case 2:
               _text = 'enable/disable';
               break;
            case 3:
               _text = 'on/off';
               break;
            case 4:
               _text = 'read/unread';
               break;
            default:
               break;
         }
      return _text;
   }

   swithContent(content, indexString: number) {
      const x = content.split('/');
      return indexString === 0 ? x[0] : x[1];
   }
}
